import { AfterViewInit, Component, ElementRef, OnDestroy, signal, viewChild, inject, computed, Signal } from '@angular/core';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';
import { ResolutionService } from '../resolution.service';
import { SignalsStoreService } from '../signals-store.service';

@Component({
  selector: 'app-shop-slider-banner',
  imports: [],
  templateUrl: './shop-slider-banner.component.html',
  styleUrl: './shop-slider-banner.component.scss'
})
export class ShopSliderBannerComponent implements OnDestroy, AfterViewInit {

  //#region Services

  #resolutionService = inject(ResolutionService);
  #signalsStoreService = inject(SignalsStoreService);

  //#endregion

  //#region Properties

  shopSlider = viewChild.required<ElementRef>('shopSlider');

  slides = signal<{ text: string; title: string; img: Signal<string> }[]>([]);

  isMobile = computed(() => this.#resolutionService.isMobile());

  isSmallMobile = computed(() => this.#resolutionService.isSmallMobile());

  slider: KeenSliderInstance | any = null;

  dotHelper = signal<number[]>([]);

  currentSlide = 0;

  isShopBannerHidden = computed(() => this.#signalsStoreService.isShopBannerHidden());

  //#endregion

  //#region Constructors

  ngAfterViewInit() {
    this.#getSlides();
  }

  ngOnDestroy() {
    if (this.slider) this.slider.destroy();
  }

  //#endregion

  //#region Methods

  #setUpDefaultSlider() {

    if (!(this.shopSlider()?.nativeElement)) return;
    this.slider = new KeenSlider(this.shopSlider().nativeElement, {
      initial: this.currentSlide,
      renderMode: 'performance',
      loop: false,
      drag: false,
      slideChanged: s => this.currentSlide = s.track.details.rel
    }, [
      (slider) => {
        let timeout: NodeJS.Timeout | null = null;
        let mouseOver = false
        function clearNextTimeout() {
          if (timeout)
            clearTimeout(timeout);
        }
        function nextTimeout() {

          if (timeout)
            clearTimeout(timeout);

          if (mouseOver) return
          timeout = setTimeout(() => {
            slider.next()
          }, 1000 * 5)
        }
        slider.on("created", () => {
          slider.container.addEventListener("mouseover", () => {
            mouseOver = true
            clearNextTimeout()
          })
          slider.container.addEventListener("mouseout", () => {
            mouseOver = false
            nextTimeout()
          })
          nextTimeout()
        })
        slider.on("dragStarted", clearNextTimeout)
        slider.on("animationEnded", nextTimeout)
        slider.on("updated", nextTimeout)
      }
    ]);

    if (this.slider.track?.details?.slides?.length) {
      this.dotHelper.set([
        ...Array(this.slider.track.details.slides.length)
      ]);
    }
  }

  #getSlides() {

    const version = 4; // Importat to change this version number when updating the images
    this.slides.set([
      {
        title: '<p class="m-0 text-white">Shop fresh & local.</p>',
        text: `<p class="m-0"><span class="text-white">Fresh Food. Whole Foods. House-Made Treats.</span></p>`,
        // img: '/assets/images/shop-slider/slide1.jpeg'
        img: computed(() => {
          const tablet = this.isMobile();
          const mobile = this.isSmallMobile();
          const folder = tablet ? 'Tablet' : mobile ? 'Mobile' : 'Desktop';
          return `/assets/images/shop-slider/${folder}/1.webp?v=${version}`
        })
      }
    ]);

    setTimeout(() => {
      this.#setUpDefaultSlider();
    });
  }

  //#endregion
}
